export default "__VITE_ASSET__FePukt2s__"